"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tester = exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _react2 = require("@jsonforms/react");

var _core = require("@jsonforms/core");

var _core2 = require("@material-ui/core");

var _MuiInputInteger = _interopRequireDefault(require("./MuiInputInteger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var renderer = function renderer(props) {
  var schema = props.schema;
  var unit = schema.unit;
  return /*#__PURE__*/React.createElement(_MuiInputInteger["default"], _extends({
    endAdornment: /*#__PURE__*/React.createElement(_core2.Typography, {
      variant: "caption",
      style: {
        marginLeft: 16
      }
    }, unit)
  }, props));
};

var tester = (0, _core.rankWith)(3, (0, _core.and)(_core.isIntegerControl, (0, _core.schemaMatches)(function (schema) {
  return schema.hasOwnProperty('unit');
})));
exports.tester = tester;

var _default = (0, _react2.withJsonFormsControlProps)(renderer);

exports["default"] = _default;